import React from 'react'
import { PageTrail } from '../../../../shared/sso-workspace/page-trail'

// AI tools telemetry's trail in the admin's top bar: Platform > AI tools
// telemetry > Sessions | Postmortems | Findings (the list page's tab), and
// ... > Sessions > <session> or ... > Postmortems > <postmortem> on a page,
// and ... > Recycle bin > Sessions | Records | Postmortems | Findings.
// Platform is the sidebar's group, not a page, so its crumb is a label that
// goes nowhere (its url only keys it, and is the admin's home).
export const TAB_LABELS = { sessions: 'Sessions', postmortems: 'Postmortems', findings: 'Findings' }

export const tabCrumb = key => ({ url: `/admin/ai-tools?tab=${key}`, text: TAB_LABELS[key] })

export const recycleCrumb = () => ({ url: '/admin/ai-tools/recycle', text: 'Recycle bin' })

export const aiToolsTrail = (...crumbs) => [
  { url: '/admin', text: 'Platform', block: true },
  { url: '/admin/ai-tools', text: 'AI tools telemetry' },
  ...crumbs
]

// crumbs: the crumbs after AI tools telemetry; a name still loading is ''.
export const AiToolsTrail = ({ crumbs = [] }) => <PageTrail trail={aiToolsTrail(...crumbs)} />
